import React from "react";

import { FormField } from "~/components/form/field";
import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";

import { Select } from "../../../_select";

import type { FormState } from "./_form-state";

export interface LabelNameProps {
	suggestions: ReadonlyArray<string>;
	state: FormState;
}

export const LabelName: React.FC<LabelNameProps> = ({ suggestions, state }) => {
	const [search, setSearch] = React.useState("");

	return (
		<FormField className="items-stretch" state={state}>
			<FormLabel asChild>
				<div>
					<FormLabel>Label Name *</FormLabel>
					<FormFieldReset />
				</div>
			</FormLabel>

			{(monitor, field) => (
				<Select
					allowArbitraryValues
					filterBy={["value"]}
					onChange={(value) => field.setInput(value)}
					onSearch={setSearch}
					options={suggestions.map((label) => ({ label, value: label }))}
					placeholder="Type to search an existing label"
					search={search}
					value={field.getInput(monitor) || undefined}
				/>
			)}
		</FormField>
	);
};
